import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

type ReslinkGuestState = {
  isMissingInventory: boolean,
  isReslinkBlockFull: boolean;
};

type ReslinkGuestActions = {
  setIsMissingInventory: (isMissingInventory: boolean) => void;
  setIsReslinkBlockFull: (isReslinkBlockFull: boolean) => void;
};

const initialState: ReslinkGuestState = {
  isMissingInventory: false,
  isReslinkBlockFull: false,
};

export const reslinkGuestStore: StateCreator<ReslinkGuestState & ReslinkGuestActions> = set => {
  return {
    ...initialState,

    setIsMissingInventory: (isMissingInventory: boolean) => {
      set(prevState => {
        return {
          ...prevState,
          isMissingInventory,
        };
      });
    },

    setIsReslinkBlockFull: (isReslinkBlockFull: boolean) => {
      set(prevState => {
        return {
          ...prevState,
          isReslinkBlockFull,
        };
      });
    },
  };
};

export const useReslinkGuestStore = createAppStore(reslinkGuestStore);
